import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isSelectingCustomer } from 'store/ui';
import {
  isAuthenticating,
  isAuthenticated,
  getActiveCustomer
} from 'store/auth';

import { Main, SelectAccount } from 'containers';
import { Spinner } from 'components/Common';
import { Login } from 'components';

export const App = ({
  isAuthenticating,
  isAuthenticated,
  isSelectingCustomer,
  activeCustomer
}) => {
  if (isAuthenticating) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%'
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (isAuthenticated) {
    if (activeCustomer) {
      if (isSelectingCustomer) {
        return <SelectAccount />;
      } else {
        return <Main />;
      }
    }

    return <SelectAccount />;
  }

  return <Login />;
};

App.propTypes = {
  isAuthenticating: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isSelectingCustomer: PropTypes.bool.isRequired,
  activeCustomer: PropTypes.object
};

App.defaultProps = {
  activeCustomer: null
};

const mapStateToProps = state => ({
  isAuthenticating: isAuthenticating(state),
  isAuthenticated: isAuthenticated(state),
  isSelectingCustomer: isSelectingCustomer(state),
  activeCustomer: getActiveCustomer(state)
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js